import { constantCase } from 'change-case';
import { RESULT_FIELDS } from '../../consts.ts';
import type { ResultDetail } from '../../../../../../../../graphql/rest-link/types.ts';
import type { SubstitutionMap } from './types.ts';

type BuildResultFieldSubstitutionsParams = {
  result: ResultDetail['result'];
};

const buildResultFieldSubstitutions = ({
  result,
}: BuildResultFieldSubstitutionsParams): SubstitutionMap =>
  RESULT_FIELDS.reduce<SubstitutionMap>((acc, field) => {
    acc[`%${constantCase(field)}%`] = result[field] ?? '';
    return acc;
  }, {});

export default buildResultFieldSubstitutions;
